import { NgModule } from '@angular/core';
import { UserRolePipe } from './user-role.pipe';
import { RoundPipe } from './round.pipe';
import { ThesisOrderStatusPipe } from './thesis-order-status.pipe';

@NgModule({
  imports: [],
  declarations: [UserRolePipe, RoundPipe, ThesisOrderStatusPipe],
  exports: [UserRolePipe, RoundPipe, ThesisOrderStatusPipe],
  providers: [UserRolePipe, RoundPipe],
})
export class CustomPipesModule {}
